import { boolean, RoomId, roomId, StreamId, streamId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStreamAudioUpdateCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStreamAudioUpdateCmd.validationSchema()
  );

  constructor(readonly value: RoomStreamAudioUpdateCmdRaw) {
    JsonSchemaValidator.assert(RoomStreamAudioUpdateCmd.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId", "isEnabled"],
      properties: {
        roomId,
        streamId,
        isEnabled: boolean
      },
      additionalProperties: false
    };
  }
}

interface RoomStreamAudioUpdateCmdRaw {
  roomId: RoomId;
  streamId: StreamId;
  isEnabled: boolean;
}
